class videosGrid {
  constructor (
    items, id, completeCallback = null, autoplay = 0, itemsPerSlide = 15,
    maxItems = null, showQuote = false) {
    this.swiper = null
    this.autoplay = autoplay
    this.id = id
    this.itemsPerSlide = itemsPerSlide
    this.items = items
    this.maxItems = maxItems ? maxItems : this.items.length
    this.loadedItems = 0
    this.initialized = false
    this.videosLoaded = false
    this.gridItemTL = null
    this.intervalHighlight = null
    this.showQuote = showQuote
    // Carousel.
    this.videoGridContainer = document.getElementById(
      this.id)
    this.videoGrid = this.videoGridContainer.querySelector('.swiper-container')
    this.videoGridWrapper = this.videoGrid.querySelector('.swiper-wrapper')
    // Modal.
    let modalId = this.videoGridContainer.getAttribute('data-modal')
    this.modal = document.getElementById(modalId)
    // Open modal when clicking on a preview.
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('video-grid--item')) {
        var item = e.target,
          index = item.getAttribute('data-index')
        // Play preview.
        self.gridPause(self.swiper)
        self.modal.classList.add('open')
        self.modal.querySelector('.swiper-container').swiper.update()
        self.modal.querySelector('.swiper-container').swiper.slideTo(index, 0)
        self.modal.querySelector('.close').
          addEventListener('click', (e) => {
            self.modal.classList.remove('open')
            self.gridPlay(self.swiper)
          })
      }
    })

    // Start.
    this.calculateMaxItems()
    // this.shuffleArray()
    this.createSlides()
    this.createCarousel()

    if (completeCallback) {
      completeCallback()
    }

    let self = this
    // Pause/Play grid videos on exit/enter grid.
    window.addEventListener('scroll', (e) => {
      let isVisible = self.isScrolledIntoView(
        this.videoGrid)
      if (isVisible === true && self.swiper) {
        self.gridPlay()
      }
      else if (isVisible === false && self.swiper) {
        self.gridPause()
        let modalCloseButton = self.modal.querySelector('.close')
        modalCloseButton.click()
      }
    })
    // Pause grid on blur.
    ifvisible.on('blur', function () {
      self.gridPause()
    })
    // Restart grid on focus.
    ifvisible.on('focus', function () {
      self.gridPlay()
    })
    // Pause grid on idle.
    ifvisible.on('idle', function () {
      self.gridPause()
    })
    // Restart grid on Wakup.
    ifvisible.on('wakeup', function () {
      self.gridPlay()
    })
  }

  calculateMaxItems () {
    this.maxItems = this.maxItems > this.items.length ? this.items.length : this.maxItems
  }

  createSlides () {
    let slide = null
    for (let i = 0; i < this.maxItems; i++) {
      let item = this.items[i]
      if (i % this.itemsPerSlide === 0) {
        slide = this.createSlide()
      }
      this.createItem(slide, item, i)
    }
  }

  createSlide () {
    let slide = document.createElement('div')
    slide.classList.add('video-grid--slide')
    slide.classList.add('swiper-slide')
    this.videoGridWrapper.appendChild(slide)
    return slide
  }

  createItem (slide, itemData, index) {
    let self = this,
      videoUrl = 'https://player.vimeo.com/video/' + itemData.vimeoId,
      vimeoId = itemData.vimeoId,
      name = itemData.name,
      location = itemData.place,
      profession = itemData.jobTitle,
      quoteBig = itemData.quote

    /**
     * Grid item.
     * @type {HTMLDivElement}
     */

    let container = document.createElement('div')
    container.classList.add('video-grid--item')
    container.setAttribute('data-video', videoUrl)
    container.setAttribute('data-quote', quoteBig)
    container.setAttribute('data-name', name)
    container.setAttribute('data-location', location)
    container.setAttribute('data-profession', profession)
    container.setAttribute('data-index', index)

    /**
     * Video.
     * @type {HTMLVideoElement}
     */

    let item = document.createElement('video')
    item.setAttribute('autoplay', 'true')
    item.setAttribute('muted', 'true')
    item.setAttribute('playsinline', 'true')
    item.setAttribute('loop', 'true')
    item.setAttribute('data-preview', vimeoId)
    item.setAttribute('preload', 'none')
    item.setAttribute('poster',
      '../assets/previews_thumbnails/' + itemData.vimeoId + '.jpg')
    item.muted = true
    item.autoplay = false

    item.addEventListener('loadeddata', (e) => {
      self.loadedItems++

      if (self.loadedItems === self.maxItems) {
        self.videosLoaded = true
      }
    })

    let itemSource = document.createElement('source')
    itemSource.setAttribute('src', '../assets/previews/' + vimeoId + '.mp4')
    item.appendChild(itemSource)

    /**
     * Details.
     * @type {HTMLDivElement}
     */

    let itemDetailsContainer = document.createElement('div')
    itemDetailsContainer.classList.add('video-grid--item-details')

    let itemName = document.createElement('div')
    itemName.classList.add('video-grid--item-name')
    itemName.textContent = name

    let itemLocation = document.createElement('div')
    itemLocation.classList.add('video-grid--item-location')
    itemLocation.textContent = location

    let itemProfession = document.createElement('div')
    itemProfession.classList.add('video-grid--item-profession')
    itemProfession.textContent = profession

    itemDetailsContainer.appendChild(itemName)
    itemDetailsContainer.appendChild(itemLocation)
    itemDetailsContainer.appendChild(itemProfession)

    /**
     * Add to DOM.
     */

    container.appendChild(item)
    container.appendChild(itemDetailsContainer)

    slide.appendChild(container)
  }

  createCarousel () {
    let self = this
    new Swiper(this.videoGrid, {
      loop: (self.items.length / self.itemsPerSlide) > 1,
      slidesPerView: 1,
      centeredSlides: true,
      speed: 500,
      threshold: 100,
      autoplay: (self.autoplay > 0 ? { delay: self.autoplay } : undefined),
      // If we need pagination
      pagination: {
        el: self.videoGridContainer.querySelector('.swiper-pagination'),
      },
      navigation: {
        nextEl: self.videoGridContainer.querySelector('.swiper-button-next'),
        prevEl: self.videoGridContainer.querySelector('.swiper-button-prev'),
      },
      watchOverflow: true,
      on: {
        init: function () {
          self.swiper = this
          introAnim()
          quoteModuleAnim()
          self.gridAnim()
          self.initialized = true
        },
        slideChange: function () {
          self.swiper = this
          // Stop previous preview.
          let previousIndex = self.swiper.previousIndex,
            previousSlide = self.swiper.slides[previousIndex],
            previousGridItems = previousSlide.getElementsByClassName(
              'video-grid--item'),
            previousTotalItems = previousGridItems.length
          for (let gridItemsIndex = 0; gridItemsIndex <
          previousTotalItems; gridItemsIndex++) {
            let gridItem = previousGridItems[gridItemsIndex]
            let gridItemPreview = gridItem.querySelector('video')
            gridItemPreview.pause()
          }
        },
        slideChangeTransitionStart: function () {
          self.swiper = this
          if (self.initialized === true) {
            self.gridAnim()
          }
        },
      },
      breakpoints: {
        768: {
          // slidesPerView: 1.1 --- 1.25, (if more than 1 slide)
          slidesPerView: 1.25,
        },
      },
    })
  }

  gridAnimReset () {
    var prevSlide = this.videoGridWrapper.querySelector('.swiper-slide-prev')
    if (prevSlide) {
      var prevGridItems = prevSlide.querySelectorAll('.video-grid--item')
      TweenMax.to(prevGridItems, 1, { opacity: 0.45, ease: 'power4.out' })
    }

    var nextSlide = this.videoGridWrapper.querySelector('.swiper-slide-next')
    if (nextSlide) {
      var nextGridItems = nextSlide.querySelectorAll('.video-grid--item')
      TweenMax.to(nextGridItems, 1, { opacity: 0.45, ease: 'power4.out' })
    }
  }

  gridAnim () {
    let self = this
    this.removeHighlight(self.swiper, self.swiper.previousIndex)
    this.gridAnimReset()
    this.gridItemTL = gsap.timeline({
      onComplete: () => {
        self.populateGrid(self.swiper)
      },
    })

    let index = self.swiper.activeIndex,
      activeSlide = self.swiper.slides[index],
      activeGridItems = activeSlide.querySelectorAll('.video-grid--item'),
      swiperButtonsPrev = self.videoGridWrapper.querySelector('.swiper-button-prev'),
      swiperButtonsNext = self.videoGridWrapper.querySelector('.swiper-button-next')

    this.gridItemTL.to(self.videoGridWrapper,
      { opacity: 1, duration: 1, ease: 'power4.out' }).
      staggerFromTo(activeGridItems, .75, { opacity: 0.25 },
        { opacity: 1, ease: 'power4.out' }, 0.1, '>+.5').
      to(swiperButtonsPrev,
        { opacity: 1, x: 0, duration: .25, ease: 'power4.out' }).
      to(swiperButtonsNext,
        { opacity: 1, x: 0, duration: .25, ease: 'power4.out' }, '>-.25')
  }

  removeHighlight (index) {
    let currentSlide = this.swiper.slides[index]
    if (currentSlide) {
      let gridItems = currentSlide.getElementsByClassName('video-grid--item')
      for (let i = 0; i < gridItems.length; i++) {
        gridItems[i].classList.remove('highlighted')
      }
    }
  }

  isScrolledIntoView (el, partial = true) {
    let rect = el.getBoundingClientRect()
    let elemTop = rect.top
    let elemBottom = rect.bottom
    // Partially visible elements return true:
    let isVisible = elemTop < window.innerHeight && elemBottom >= 0
    // Only completely visible elements return true:
    if (partial === false) {
      isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight)
    }
    return isVisible
  }

  highlightItem (currentSlide, index) {
    let gridItems = currentSlide.getElementsByClassName('video-grid--item'),
      totalGridItems = gridItems.length,
      highlightIndex = index + 1 // remove + 1 for random
    // For linear
    if (highlightIndex >= totalGridItems) {
      highlightIndex = 0
    }
    // For random
    /*while (highlightIndex === index) {
      highlightIndex = Math.floor(Math.random() * totalGridItems)
    }*/
    let gridItem = gridItems[highlightIndex]
    if (gridItem) {
      gridItem.classList.add('highlighted')
      let quoteContainer = document.getElementById('worker-quote--container'),
        quoteBig = gridItem.getAttribute('data-quote'),
        name = gridItem.getAttribute('data-name'),
        location = gridItem.getAttribute('data-location'),
        profession = gridItem.getAttribute('data-profession')
      if (quoteContainer) {
        quoteContainer.classList.remove('visible')
        quoteContainer.querySelector('#worker_quote').innerHTML = quoteBig
        quoteContainer.querySelector('#quote_worker_name').innerHTML = name
        quoteContainer.querySelector(
          '#quote_worker_location').innerHTML = location
        quoteContainer.querySelector(
          '#quote_worker_profession').innerHTML = profession

        setTimeout(function () {
          quoteContainer.classList.add('visible')
        }, 500)
      }
    }

    return highlightIndex
  }

  gridPause () {
    let index = this.swiper.activeIndex,
      currentSlide = this.swiper.slides[index],
      gridItems = currentSlide.getElementsByClassName('video-grid--item'),
      totalGridItems = gridItems.length
    // Play preview.
    for (let gridItemsIndex = 0; gridItemsIndex <
    totalGridItems; gridItemsIndex++) {
      let gridItem = gridItems[gridItemsIndex]
      let gridItemPreview = gridItem.querySelector('video')
      gridItemPreview.pause()
    }
  }

  gridPlay () {
    let index = this.swiper.activeIndex,
      currentSlide = this.swiper.slides[index],
      gridItems = currentSlide.getElementsByClassName('video-grid--item'),
      totalGridItems = gridItems.length
    // Play preview.
    for (let gridItemsIndex = 0; gridItemsIndex <
    totalGridItems; gridItemsIndex++) {
      let gridItem = gridItems[gridItemsIndex]
      let gridItemPreview = gridItem.querySelector('video')
      gridItemPreview.play()
    }
  }

  populateGrid () {
    let self = this,
      index = self.swiper.activeIndex,
      currentSlide = self.swiper.slides[index],
      highlightIndex = -1
    // Play preview.
    this.gridPlay()
    // Highlight periodically.
    if (this.showQuote) {
      if (this.intervalHighlight) {
        clearInterval(this.intervalHighlight)
      }
      setTimeout(() => {
        self.removeHighlight(index)
        highlightIndex = self.highlightItem(currentSlide, highlightIndex)
      }, 1000)
      setTimeout(() => {
        this.intervalHighlight = setInterval(() => {
          self.removeHighlight(index)
          highlightIndex = self.highlightItem(currentSlide, highlightIndex)
        }, 10000)
      }, 10)
    }
  }

  shuffleArray () {
    for (let i = this.items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * i)
      const temp = this.items[i]
      this.items[i] = this.items[j]
      this.items[j] = temp
    }
  }
}